import { TableCard } from 'app/components'
import { LogsUsuarioListHeader } from './components/header/LogsUsuarioListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { LogsUsuarioTable } from './table/LogsUsuarioTable'

const LogsUsuarioList = () => {
  return (
    <TableCard>
      <LogsUsuarioListHeader />
      <LogsUsuarioTable />
    </TableCard>
  )
}

export const LogsUsuarioListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <LogsUsuarioList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
